module.exports = "/assets/_next/static/images/clouds-right-7031ef0d886b707cbb18a0118c950ee2.png";